/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Share_Links_CountInputs */

const en_team_share_links_count = /** @type {(inputs: Team_Share_Links_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Links`)
};

const fr_team_share_links_count = /** @type {(inputs: Team_Share_Links_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} liens`)
};

const de_team_share_links_count = /** @type {(inputs: Team_Share_Links_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Links`)
};

const it_team_share_links_count = /** @type {(inputs: Team_Share_Links_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Collegamenti`)
};

const ru_team_share_links_count = /** @type {(inputs: Team_Share_Links_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Ссылки`)
};

const es_team_share_links_count = /** @type {(inputs: Team_Share_Links_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Enlaces`)
};

const zh_cn2_team_share_links_count = /** @type {(inputs: Team_Share_Links_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 链接`)
};

const ja_team_share_links_count = /** @type {(inputs: Team_Share_Links_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} リンク`)
};

const hi_team_share_links_count = /** @type {(inputs: Team_Share_Links_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} लिंक`)
};

const pt_pt2_team_share_links_count = /** @type {(inputs: Team_Share_Links_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Links`)
};

/**
* | output |
* | --- |
* | "{count} Links" |
*
* @param {Team_Share_Links_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_links_count = /** @type {((inputs: Team_Share_Links_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Links_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_links_count(inputs)
	if (locale === "de") return de_team_share_links_count(inputs)
	if (locale === "it") return it_team_share_links_count(inputs)
	if (locale === "ru") return ru_team_share_links_count(inputs)
	if (locale === "es") return es_team_share_links_count(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_links_count(inputs)
	if (locale === "ja") return ja_team_share_links_count(inputs)
	if (locale === "hi") return hi_team_share_links_count(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_links_count(inputs)
	return en_team_share_links_count(inputs)
});